import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const avgrevenueService = {
  avgWeightByService: async (branchId: string, endDate: string) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/avgrevenue/avg-weight-by-service`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id: branchId, end_date: endDate }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch average weight by service");
    }

    const json = await response.json();
    return json.data;
  },

  avgPiecesByService: async (branchId: string, endDate: string) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/avgrevenue/avg-pieces-by-service`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id: branchId, end_date: endDate }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch average pieces by service");
    }

    const json = await response.json();
    return json.data;
  },

  avgWeightPerPieces: async (branchId: string, endDate: string) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/avgrevenue/avg-weight-by-pieces`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id: branchId, end_date: endDate }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch average weight per pieces");
    }

    const json = await response.json();
    return json.data;
  },
};
